// @flow

import _ from 'lodash';
const PhoneNumberFormat = require('google-libphonenumber').PhoneNumberFormat;
const PhoneNumberUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
import StringUtils from './StringUtils';

/**
 * Tools to manipulate phone numbers.
 * Use https://github.com/seegno/google-libphonenumber, abstract of
 * https://github.com/googlei18n/libphonenumber
 */
export default class PhoneUtils {

  static MIN_LENGHT_FOR_NUMBER: number = 3;

  static format(number: string) {
    if (_.isNull(number) || number.length <= PhoneUtils.MIN_LENGHT_FOR_NUMBER) {
      return number;
    }
    try {
      const phoneNumber = PhoneNumberUtil.parse(number);
      return PhoneNumberUtil.format(phoneNumber, PhoneNumberFormat.INTERNATIONAL);
    } catch (e) {
      console.log(e);
    }

    return number;
  }

  static isValid(number: string) {
    if (_.isNull(number) || number.length <= PhoneUtils.MIN_LENGHT_FOR_NUMBER) {
      return false;
    }

    try {
      const phoneNumber = PhoneNumberUtil.parse(number);
      return PhoneNumberUtil.isValidNumber(phoneNumber);
    }
    catch (e) {
      console.log(e);
    }

    return false;
  }

  /**
   *
   * @param number
   * @param countryIso
   * @returns {*}
   */
  static parseWithIso(number: string, countryIso: string) {
    const countryCode = PhoneNumberUtil.getCountryCodeForRegion(countryIso);
    let parsedPhone = number;

    if (!_.isEmpty(number)) {
      try {
        const phoneNumber = PhoneNumberUtil.parse(number, countryIso.toUpperCase());
        parsedPhone = PhoneNumberUtil.format(phoneNumber, PhoneNumberFormat.INTERNATIONAL);
      } catch (e) {
        console.log(e);
      }
    }

    return {
      country_code: countryCode,
      national_number: parsedPhone
    };
  }

  static getCountryIndicatorFromNumber(number: string) {
    if (!_.isEmpty(number)) {
      try {
        const phoneNumber = PhoneNumberUtil.parse(number, '');
        return phoneNumber.getCountryCode();
      } catch (e) {
        console.log(e);
      }
    }
    return null;
  }

  static getCountryIsoForNumber(number: string): string {
    if (!_.isEmpty(number)) {
      try {
        const phoneNumber = PhoneNumberUtil.parse(number, '');
        https://github.com/googlei18n/libphonenumber/blob/master/javascript/i18n/phonenumbers/phonenumberutil.js#L2851

        return PhoneNumberUtil.getRegionCodeForNumber(phoneNumber);
      } catch (e) {
        console.log(e);
      }
    }

    return null;
  }


  static removeIndicatorOnPhoneNumber(phoneNumber: string) {
    if (!_.isEmpty(phoneNumber)) {
      const haveIndicator = phoneNumber.indexOf('+') !== -1;

      if (haveIndicator !== -1) {
        const firstSpaceIndex = phoneNumber.indexOf(' ');
        return phoneNumber.substring(firstSpaceIndex + 1);
      }
    }

    return phoneNumber;
  }

  /**
   * Inspired by https://github.com/PayMyTable/pmt_AppEngine/blob/develop/ws/src/main/java/com/paymytable/utils/PhoneUtils.java
   */
  static cleanForApi(phoneNumber: string): string {
    if (_.isNil(phoneNumber)) {
      return '';
    }
    let cleanPhoneNumber = PhoneUtils.format(phoneNumber);
    console.log('after format', cleanPhoneNumber);

    if (cleanPhoneNumber.indexOf("+330") === 0) {
      cleanPhoneNumber = cleanPhoneNumber.replace("+330", "+33");
    }

    if (cleanPhoneNumber.indexOf("06") === 0) {
      cleanPhoneNumber = cleanPhoneNumber.replace("06", "+336");
    }

    if (cleanPhoneNumber.indexOf("07") === 0) {
      cleanPhoneNumber = cleanPhoneNumber.replace("07", "+337");
    }

    // removeAllSpaces
    cleanPhoneNumber = StringUtils.replaceAll(cleanPhoneNumber, ' ', '');

    return cleanPhoneNumber;
  }
}
